import { AuthViewModel } from "../viewmodels/AuthViewModel.js";
import { useSingleton } from "mvc-kit/react";
// src/modules/AuthWrapper2/hooks/useCurrentIdentityInfo.ts
function useCurrentIdentityInfo() {
	return useSingleton(AuthViewModel).state.identityInfo;
}
export { useCurrentIdentityInfo };

//# sourceMappingURL=useCurrentIdentityInfo.js.map